<div
  class="canvas-editor-container"
  *ngIf="
    !canvasService.isLoadingDocument && document && currentVersionDocuemnt;
    else loader
  "
>
  <div class="canvas-editor-header">
    <div class="canvas-editor-title">
      <img
        src="../../../../assets/icons/svg/close-square.svg"
        alt="Drawer"
        height="25"
        width="25"
        class="canvas-editor-action-button action-icon"
        (click)="
          canvasService.closeOutline(); canvasService.clearDocumentTypeChats()
        "
        (keydown)="
          canvasService.closeOutline(); canvasService.clearDocumentTypeChats()
        "
      />
      <span
        class="canvas-editor-title-text"
        [ngClass]="{
          'hyperlink-title': document?.conversation_id
        }"
        (click)="
          document?.conversation_id && canvasService.scrollDown({
            _id: document?.conversation_id,
          }, true)"
        (keydown)="
          document?.conversation_id && canvasService.scrollDown({
            _id: document?.conversation_id,
          }, true)"
        >{{ currentVersionDocuemnt?.title }}</span
      >
    </div>

    <div
      class="canvas-editor-action-container me-2"
      *ngIf="document && currentVersionDocuemnt"
    >
      <img
        *ngIf="currentVersionDocuemnt?.sources?.length > 0"
        src="../../../../assets/icons/svg/chat-info.svg"
        alt="Citations"
        height="22"
        width="22"
        class="canvas-editor-action-button action-icon"
        matTooltipPosition="below"
        [matTooltipClass]="['header-saved-search-item-theme']"
        matTooltip="Citations"
        (click)="
          canvasService.openCitationsDialog(currentVersionDocuemnt?.sources)
        "
        (keydown)="
          canvasService.openCitationsDialog(currentVersionDocuemnt?.sources)
        "
      />

      <img
        *ngIf="currentVersionDocuemnt?.stats"
        src="../../../../assets/icons/svg/chat-cost.svg"
        alt="Cost"
        height="22"
        width="22"
        class="canvas-editor-action-button action-icon"
        matTooltipPosition="below"
        [matTooltipClass]="['header-saved-search-item-theme']"
        matTooltip="{{
          helperService.getStatsTooltip(currentVersionDocuemnt.stats)
        }}"
      />

      <ng-container *ngIf="document?.type != chatTypes.SCORECARD">
        <ng-container
          *ngIf="!isNextVersionAvailable() && !canvasService.isSessionReadOnly"
        >
          <img
            *ngIf="!isSavingDocument; else savingDocument"
            src="../../../../assets/icons/svg/chat-save.svg"
            alt="Save"
            height="25"
            width="25"
            class="canvas-editor-action-button action-icon save"
            [ngClass]="{ enable: isCanvasDirty, disabled: !isCanvasDirty }"
            (click)="saveDocument()"
            (keydown)="saveDocument()"
            matTooltipPosition="below"
            [matTooltipClass]="['header-saved-search-item-theme']"
            matTooltip="Save document"
          />
          <ng-template #savingDocument>
            <span class="spinner-border spinner-border-save"></span>
          </ng-template>
        </ng-container>

        <img
          src="../../../../assets/icons/svg/chat-compare-version.svg"
          alt="Compare"
          height="22"
          width="22"
          class="canvas-editor-action-button action-icon disabled"
          [ngClass]="{
            'active-icon': viewType == viewTypes.Comparison,
            enabled: currentVersionDocuemnt?.compare_with_previous?.length > 0
          }"
          (click)="compareVersion()"
          (keydown)="compareVersion()"
          matTooltipPosition="below"
          [matTooltipClass]="['header-saved-search-item-theme']"
          matTooltip="Compare"
        />

        <img
          src="../../../../assets/icons/svg/chat-left-arrow.svg"
          alt="Previous"
          height="25"
          width="25"
          class="canvas-editor-action-button action-icon disabled"
          [ngClass]="{ enabled: isPreviousVersionAvailable() }"
          (click)="previousVersion()"
          (keydown)="previousVersion()"
          matTooltipPosition="below"
          [matTooltipClass]="['header-saved-search-item-theme']"
          matTooltip="Previous Version"
        />
        <img
          src="../../../../assets/icons/svg/chat-right-arrow.svg"
          alt="Next"
          height="25"
          width="25"
          class="canvas-editor-action-button action-icon disabled"
          [ngClass]="{ enabled: isNextVersionAvailable() }"
          (click)="nextVersion()"
          (keydown)="nextVersion()"
          matTooltipPosition="below"
          [matTooltipClass]="['header-saved-search-item-theme']"
          matTooltip="Next Version"
        />
      </ng-container>

      <img
        src="../../../../assets/icons/svg/copy-message-blue.svg"
        alt="Copy"
        height="22"
        width="22"
        class="canvas-editor-action-button action-icon"
        (click)="copyContent()"
        (keydown)="copyContent()"
        matTooltipPosition="below"
        [matTooltipClass]="['header-saved-search-item-theme']"
        matTooltip="Copy document"
      />

      <img
        *ngIf="!isDownloadingDocument; else downloadingDocument"
        src="../../../../assets/icons/svg/chat-export.svg"
        alt="Export"
        height="21"
        width="21"
        class="canvas-editor-action-button action-icon"
        (click)="exportDocument()"
        (keydown)="exportDocument()"
        matTooltipPosition="below"
        [matTooltipClass]="['header-saved-search-item-theme']"
        matTooltip="Export document"
      />
      <ng-template #downloadingDocument>
        <span class="spinner-border spinner-border-save"></span>
      </ng-template>
    </div>
  </div>

  <div class="editor-wrapper">
    <ng-container *ngIf="viewType == viewTypes.Canvas; else compareVersions">
      <app-canvas-custom-action-dialog
        class="toolbar"
        *ngIf="
          isContentSelectionToolbarActive &&
          document?.type != chatTypes.SCORECARD
        "
        [style.top.px]="toolbarPosition.y"
        [style.left.px]="toolbarPosition.x"
        [origin]="toolbarPosition.origin"
        (onSetToolbarChatEvent)="setToolbarChat()"
        (onSendCanvasQueryEvent)="sendCanvasQuery($event)"
        (onApplyStyleEvent)="
          applyStyle($event);
          isContentSelectionToolbarActive = false;
          isCanvasDirty = true
        "
      />

      <div
        [attr.contenteditable]="!isContentReadOnly()"
        spellcheck="false"
        autocomplete="on"
        #editor
        class="scrolled-content scrollbar-custom-scroll-style"
        [innerHtml]="currentVersionDocuemnt?.convertedContent"
        (mouseup)="onMouseUp($event)"
        (click)="onSectionTitleClick($event)"
        (keydown)="canvasService.onKeyDown($event)"
      ></div>
    </ng-container>
    <ng-template #compareVersions>
      <div
        [attr.contenteditable]="false"
        spellcheck="false"
        autocomplete="on"
        class="scrolled-content scrollbar-custom-scroll-style"
        [innerHtml]="currentVersionDocuemnt?.convertedCompareContent"
      ></div>
    </ng-template>
  </div>
</div>
<ng-template #loader>
  <ng-container *ngIf="canvasService.isLoadingDocument; else failure">
    <div class="canvas-editor-container">
      <div class="scrolled-content px-1 pt-2 overflow-hidden">
        <div class="canvas-editor-header justify-content-end">
          <div class="canvas-editor-title">
            <img
              src="../../../../assets/icons/svg/close-square.svg"
              alt="Close"
              height="25"
              width="25"
              class="canvas-editor-action-button action-icon"
              (click)="
                canvasService.closeOutline();
                canvasService.clearDocumentTypeChats()
              "
              (keydown)="
                canvasService.closeOutline();
                canvasService.clearDocumentTypeChats()
              "
            />
          </div>
        </div>
        <app-canvas-loader
          [loaderType]="loaderTypes.ROBOT"
          [robotStatus]="loaderTypes.ROBOT_LOADING"
        />
      </div>
    </div>
  </ng-container>
  <ng-template #failure>
    <div class="canvas-editor-container">
      <div class="scrolled-content px-1 pt-2 overflow-hidden">
        <div class="canvas-editor-header justify-content-end">
          <div class="canvas-editor-title">
            <img
              src="../../../../assets/icons/svg/close-square.svg"
              alt="Close"
              height="25"
              width="25"
              class="canvas-editor-action-button action-icon"
              (click)="
                canvasService.closeOutline();
                canvasService.clearDocumentTypeChats()
              "
              (keydown)="
                canvasService.closeOutline();
                canvasService.clearDocumentTypeChats()
              "
            />
          </div>
        </div>
        <app-canvas-loader
          [loaderType]="loaderTypes.ROBOT"
          [robotStatus]="loaderTypes.ROBOT_ERROR"
        />
      </div>
    </div>
  </ng-template>
</ng-template>
